/*!
 * devextreme-angular
 * Version: 22.2.5
 * Build date: Mon Mar 27 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from 'devextreme-angular/core';
import {
    Component,
} from '@angular/core';

import { Store } from 'devextreme/data';
import { Options as DataSourceOptions } from 'devextreme/data/data_source';
import { dxGanttHeaderFilterTexts } from 'devextreme/ui/gantt';

@Component({
    template: ''
})
export abstract class DxoGanttHeaderFilter extends NestedOption {
    get allowSearch(): boolean | undefined {
        return this._getOption('allowSearch');
    }
    set allowSearch(value: boolean | undefined) {
        this._setOption('allowSearch', value);
    }

    get dataSource(): DataSourceOptions | Store | Function | null | undefined | Array<any> {
        return this._getOption('dataSource');
    }
    set dataSource(value: DataSourceOptions | Store | Function | null | undefined | Array<any>) {
        this._setOption('dataSource', value);
    }

    get groupInterval(): number | string | undefined {
        return this._getOption('groupInterval');
    }
    set groupInterval(value: number | string | undefined) {
        this._setOption('groupInterval', value);
    }

    get height(): number | undefined {
        return this._getOption('height');
    }
    set height(value: number | undefined) {
        this._setOption('height', value);
    }

    get searchMode(): string {
        return this._getOption('searchMode');
    }
    set searchMode(value: string) {
        this._setOption('searchMode', value);
    }

    get width(): number | undefined {
        return this._getOption('width');
    }
    set width(value: number | undefined) {
        this._setOption('width', value);
    }

    get searchTimeout(): number {
        return this._getOption('searchTimeout');
    }
    set searchTimeout(value: number) {
        this._setOption('searchTimeout', value);
    }

    get texts(): { cancel?: string, emptyValue?: string, ok?: string } | dxGanttHeaderFilterTexts {
        return this._getOption('texts');
    }
    set texts(value: { cancel?: string, emptyValue?: string, ok?: string } | dxGanttHeaderFilterTexts) {
        this._setOption('texts', value);
    }

    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    get showRelevantValues(): boolean {
        return this._getOption('showRelevantValues');
    }
    set showRelevantValues(value: boolean) {
        this._setOption('showRelevantValues', value);
    }
}
